import { render, staticRenderFns } from "./copycommand.vue?vue&type=template&id=347c2f94&"
import script from "./copycommand.vue?vue&type=script&lang=ts&"
export * from "./copycommand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copycommand.vue"
export default component.exports